import Container from "www/shared/components/container/Container";
import { Button } from "www/shared/components/buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/pro-thin-svg-icons";
import { useState } from "react";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { addWaitlistEntry } from "www/pages/home/UserHome.fetchers";
import { WaitlistSuccess } from "www/pages/home/HomeHero";

const InvestorsHero = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");

  const addWaitlistEntryMutate = useMutation(addWaitlistEntry);
  const onSignUp = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    addWaitlistEntryMutate.mutate(email, {
      onSuccess: () => {
        setIsOpen(true);
      },
      onError: (err) => {
        toast.error(
          "Something went wrong. Please double check you've entered a valid email and try again later. If the issue persists, please contact us at team@elmbase.com."
        );
        console.log(err);
      },
    });
  };

  return (
    <section className="h-screen flex flex-col items-center justify-center bg-[url('/marketing/sponsors/hero/hero_bg.jpg')] bg-center bg-cover">
      <Container className="text-center">
        <span className="text-slate-700 text-sm font-semibold">
          For Investors
        </span>
        <h2 className="text-slate-900 text-3xl sm:text-4xl lg:text-6xl font-semibold flex flex-col items-center gap-y-2 sm:gap-y-3 mt-3">
          <span className="text-green-700">Organize your investments</span> in
          one dashboard.
        </h2>
        <p className="text-gray-500 text-sm sm:text-base lg:text-xl font-light mt-6 sm:mt-8 lg:mt-10">
          Simplify tracking, gain clarity, and unlock insights for your{" "}
          <span className="font-medium">private equity investments</span>.
        </p>
        <div className="lg:p-6 p-4 bg-white max-w-[640px] mt-8 lg:mt-10 mx-auto rounded-md shadow-[0px_10px_30px_rgba(0,0,0,0.1)]">
          <div className="w-full flex sm:gap-5 gap-2 items-center sm:flex-row flex-col">
            <div className={`mt-1 flex rounded-md shadow-sm w-full flex-1`}>
              <span className="inline-flex rounded-l-[5px] border border-r-0 border-gray-200 bg-[rgba(209,219,227,0.2)] px-3 text-sm text-gray-500 sm:h-[60px] h-[42px] w-[59px] justify-center items-center">
                <FontAwesomeIcon icon={faEnvelope} className="h-6 w-6" />
              </span>
              <div className="relative rounded-md  w-full">
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-r-md border-l-0 border-gray-300 px-4 py-[20px] focus:border-green-500 focus:ring-green-500 sm:text-sm sm:h-[60px] h-10 font-light text-sm leading-[17px] text-[#828B93] bg-white"
                  placeholder="Your Email"
                />
              </div>
            </div>
            <Button
              className="px-5 lg:px-6 py-2 lg:py-3 sm:py-[20px] sm:px-[26px] sm:h-[60px] h-10 sm:w-auto w-full"
              onClick={onSignUp}
            >
              Join waitlist
            </Button>
          </div>
        </div>
        <p className="text-center text-gray-500 text-xs mt-4">
          Currently the platform is referrals-only. Join the waitlist to be
          invited for early access.
        </p>
        <WaitlistSuccess isOpen={isOpen} setIsOpen={setIsOpen} />
      </Container>
    </section>
  );
};

export default InvestorsHero;
